import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import {
  removeReadOnlyFields,
  timestampToDate,
} from 'src/utils/fieldNormalizers';

import { FbmResource } from './_types';

const readOnlyFields = ['created_at', 'updated_at'];

export function normalizeFbmResource(fbmResource): FbmResource {
  const camelized = camelcaseKeys(fbmResource, { deep: true });

  return {
    ...camelized,
    createdAt: timestampToDate(camelized.createdAt),
    updatedAt: timestampToDate(camelized.updatedAt),
  };
}

export function denormalizeFbmResource(fbmResource: Partial<FbmResource>) {
  const decamelized = decamelizeKeys(fbmResource, { deep: true });

  removeReadOnlyFields(decamelized, readOnlyFields);

  return {
    ...decamelized,
  };
}
